import React, { Component } from 'react';
import { Row, Col, Table } from "react-bootstrap";

import { ConsultaEventos } from '../../funciones/AgendaFunction';

class Agenda extends Component {
    state = {
        eventos: [],
        dia: this.props.dia,
        fecha: "",
        preloader: {
            text: "Buscando eventos, espera por favor",
            icon: "fa fa-spinner fa-spin"
        },
        preloader2: ""
    }

    constructor (props) {
        super (props);

        ConsultaEventos(this.state.dia, (resp) => {
            if (resp.length === 0 ) this.setState ({
                preloader: {
                    text: "No existen eventos para este día",
                    icon: ""
                }
            })
            this.setState({ eventos:resp })
        });
    }
    
    componentWillReceiveProps = (props) => {
        this.setState({
            preloader2: {
                text: "Buscando eventos, espera por favor",
                icon: "fa fa-spinner fa-spin"
            }
        },() => {
            ConsultaEventos(props.dia, (resp) => {
                if (resp.length === 0 ) this.setState ({
                    preloader2: "",
                    preloader: {
                        text: "No existen eventos para este día",
                        icon: ""
                    }
                })
                this.setState({
                    preloader2: "",
                    eventos:resp
                })
            }); 
        })
    }

    fechaLarga = () => {
        let diaSep = this.props.dia.split("/");
        let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
        return `${diaSep[0]} de ${meses[diaSep[1]-1]} de ${diaSep[2]}`
    }

    contenidoTable = () => {
        let { eventos, } = this.state;

        if (eventos.length === 0){
            return (
                <tr>
                    <td align= "center" style={{padding: 15, fontSize: 12}}>
                        <i className={this.state.preloader.icon}></i> {this.state.preloader.text}
                    </td>
                </tr>
            )
        }

        return (
            eventos.map(option => (
                <tr key ={option.id}>
                    <td width={20} style={{borderLeft:`solid 3px #${option.codigo_color}`, padding:5}} align="center">
                        <i className="fa fa-circle" style={{color: option.codigo_color}}></i>
                    </td>
                    <td style={{padding: 15, fontSize: 12, borderRight:`solid 3px #${option.codigo_color}`}}>
                        {option.event_name}
                    </td>
                </tr>
            ))
        )
    }

    render() {
        let { preloader2 } = this.state;
        return (
            <React.Fragment>
                <div className="custom-alert-info">Actividades del dia <strong>{this.fechaLarga()}</strong></div>
                <div align="center" className="text-muted custom-mt-10" style={{fontSize:12}}><i className={preloader2.icon}></i> {preloader2.text}</div>
                <div className="table-responsive">
                    <Table hover>
                        <tbody>
                            {this.contenidoTable()}
                        </tbody>
                    </Table>
                </div>
            </React.Fragment>
        );
    }
}
 
export default Agenda;


// WEBPACK FOOTER //
// ./src/views/Noticias/Agenda.jsx